import type { IntlShape } from 'react-intl'
import type { PaymentMethodHeader } from './types'

export const paymentMethodHeaders: PaymentMethodHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Koodi',
				description: 'Table column header: Code',
			}),
		key: 'code', //TODO:
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Kuvaus',
				description: 'Table column header: Description',
			}),
		key: 'description', //TODO:
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Käytetty',
				description: 'Table column header: Used',
			}),
		key: 'used', //TODO:
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: true,
	},
]
export const paymentMethodFormHeaders: PaymentMethodHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Koodi',
				description: 'Table column header: Code',
			}),
		key: 'code', //TODO:
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Kuvaus',
				description: 'Table column header: Description',
			}),
		key: 'description', //TODO:
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tilinumero',
				description: 'Table column header: Account number',
			}),
		key: 'accountNumber', //TODO:
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'IBAN',
				description: 'Table column header: Iban',
			}),
		key: 'iban', //TODO:
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'BIC',
				description: 'Table column header: Bic',
			}),
		key: 'bic', //TODO:
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tili',
				description: 'Table column header: Account',
			}),
		key: 'account', //TODO:
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Maksujen palvelutunnus',
				description: 'Table column header: Payment service identifier',
			}),
		key: 'paymentServiceIdentifier', //TODO:
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Oletus suoritustapa',
				description: 'Table column header: Default',
			}),
		key: 'default', //TODO:
		show: true,
		sortable: true,
		type: 'boolean',
		fullWidth: true,
	},
]
